// extracted by mini-css-extract-plugin
export default {"controls":"lsf-controls","controls__tooltip-wrapper":"lsf-controls__tooltip-wrapper","controls__skipped-info":"lsf-controls__skipped-info","button":"lsf-button","action-dialog":"lsf-action-dialog","action-dialog__input-title":"lsf-action-dialog__input-title","action-dialog__input":"lsf-action-dialog__input","action-dialog__footer":"lsf-action-dialog__footer","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630375304
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  